/*
  B.Util.js 의 localStorage 객체의 코드를 그대로 사용 함.
 */
export const BrunchLocalStorage = {
    isEnable: () => !!(window.localStorage && window.localStorage.getItem),

    set: (key, value) => {
        if (window.localStorage && window.localStorage.setItem) {
            try {
                window.localStorage.setItem(key, value);
                return true;
            } catch (e) {
                console.error(e);
            }
        }

        return false;
    },

    get: (key) => {
        if (window.localStorage && window.localStorage.getItem) {
            return window.localStorage.getItem(key);
        }

        return null;
    },

    remove: (key) => {
        if (window.localStorage && window.localStorage.removeItem) {
            window.localStorage.removeItem(key);
        }
    },
};
